// Shape a feature for the create/update payload. Optional fields (badge, surface) are only sent
// when set so saving from the panel never drops them.
export const normalizeFeature = (feature) => ({
  key: feature.key,
  title: feature.title,
  description: feature.description ?? '',
  ...(feature.badge !== undefined ? { badge: feature.badge } : {}),
  ...(feature.surface !== undefined ? { surface: feature.surface } : {}),
  isActive: typeof feature.isActive === 'boolean' ? feature.isActive : true
});
